module.exports = __webpack_public_path__ + "static/banner-mobile-pt-799db7b526f193111f7b5a6601df5f5e.png";